import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-left">
          <p className="mb-0">Compara i prezzi dei prodotti che ami</p>
        </div>
        <div className="navbar-right">
          <Link to="/" className="navbar-link">Home</Link>
          <Link to="/account" className="navbar-link">Account</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
